import { render } from "./Home.vue?vue&type=template&id=06c94614"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/home/abushotal/Documents/VUE PROJECTS/KHL PRORTALS/courseatk_sudani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__